 (function () {
    'use strict';

    // Optimized slider with debounce and passive listeners
    const sliders = document.querySelectorAll('[data-slider]');

    sliders.forEach(function (slider) {
      const track = slider.querySelector('[data-slider-track]');
      if (!track) return;

      const slides = track.querySelectorAll('[data-slide]');
      const dots = slider.querySelectorAll('[data-dot]');

      if (!slides.length || !dots.length) return;

      let isScrolling = false;
      let scrollTimeout;

      function setActive(index) {
        dots.forEach(function (dot) {
          dot.classList.remove('active');
        });
        if (dots[index]) {
          dots[index].classList.add('active');
        }
      }

      // Dot click handler
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          const slideOffset = slides[index].offsetLeft;
          track.scrollTo({
            left: slideOffset,
            behavior: 'smooth',
          });
          setActive(index);
        });
      });

      // Optimized scroll handler with debounce
      function handleScroll() {
        if (isScrolling) return;

        isScrolling = true;

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          let activeIndex = 0;
          const scrollLeft = track.scrollLeft;

          slides.forEach(function (slide, index) {
            if (scrollLeft >= slide.offsetLeft - slide.offsetWidth / 2) {
              activeIndex = index;
            }
          });

          setActive(activeIndex);
          isScrolling = false;
        }, 100);
      }

      // Use passive listener for better scroll performance
      track.addEventListener('scroll', handleScroll, { passive: true });

      // Initialize
      setActive(0);
    });
  })();